import React from 'react';
import {connect} from 'react-redux';
import {CallbackComponent} from 'redux-oidc';
import {userManager} from '../../Utilities';
import {history, linkPath} from '../../Config';

class CallbackPage extends React.Component {
    render() {
        return (
            <CallbackComponent
                userManager={userManager}
                successCallback={(user) => {
                    if (user.state.redirectUrl !== null)
                        window.location.href = user.state.redirectUrl;
                    else history.push(linkPath.listKyc.url);
                }}
                errorCallback={error => {
                    history.push(linkPath.index.url);
                    console.error(error);
                }}
            >
                <div>Redirecting...</div>
            </CallbackComponent>
        );
    }
}

const connectedCallbackPage = connect()(CallbackPage);
export {connectedCallbackPage as CallbackPage}